import { render, staticRenderFns } from "./TiktokConfiguration.vue?vue&type=template&id=15dd45e1"
import script from "./TiktokConfiguration.vue?vue&type=script&lang=js"
export * from "./TiktokConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TiktokConfiguration.vue?vue&type=style&index=0&id=15dd45e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports